import React from 'react'
import PropTypes from 'prop-types'

export const Detail = ({ label, data, labelFlexBasis }) => (
  <div style={{ display: 'flex', flexBasis: '50%' }}>
    <strong style={{ flexBasis: `${labelFlexBasis}%` }}>{label}</strong>
    <div style={{ flexBasis: `${100 - labelFlexBasis}%` }}>: {data}</div>
  </div>
)

Detail.propTypes = {
  label: PropTypes.string.isRequired,
  data: PropTypes.string,
  labelFlexBasis: PropTypes.number,
}

Detail.defaultProps = {
  data: '',
  labelFlexBasis: 50,
}
